// Environment detection utilities
// Used to determine deployment context and adjust UI accordingly

/**
 * Detects if the current environment is a Firebase PR preview deployment
 * PR preview domains follow the pattern: projectid--pr-{number}-{hash}.web.app
 */
export const isPRPreviewEnvironment = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;

  // Check for Firebase PR preview pattern
  return (
    hostname.includes('--pr-') &&
    (hostname.endsWith('.web.app') || hostname.endsWith('.firebaseapp.com'))
  );
};

/**
 * Extracts the PR number from a PR preview URL
 * Returns null if not a PR preview environment
 */
export const getPRNumber = (): string | null => {
  if (!isPRPreviewEnvironment()) return null;

  const hostname = window.location.hostname;
  const match = hostname.match(/--pr-(\d+)-/);
  return match ? match[1] : null;
};

/**
 * Gets a human-readable description of the current environment
 */
export const getEnvironmentDescription = (): string => {
  if (isPRPreviewEnvironment()) {
    const prNumber = getPRNumber();
    return prNumber ? `PR Preview #${prNumber}` : 'PR Preview';
  }

  const hostname = window.location.hostname;

  if (hostname.includes('dev.heapster.id')) {
    return 'Development';
  }

  if (hostname.includes('staging.heapster.id')) {
    return 'Staging';
  }

  if (hostname.includes('heapster.id')) {
    return 'Production';
  }

  if (hostname === 'localhost') {
    return 'Local Development';
  }

  return 'Unknown Environment';
};
